import { GlobalFooter as UniformGlobalFooter } from "@/patterns/global-footer/src";
export type { GlobalFooterPatternProps } from "@/patterns/global-footer/src/global-footer";

export default UniformGlobalFooter;
